module.exports = __webpack_public_path__ + "img/clone.a93ca91d.svg";